<img *ngIf="isLoading" [style.width]="widthInPx" [style.height]="heightInPx" class="shared-refresh-loader"
    src="../../assets/fi-refresh-circular-spinner.png" alt="Loading.." />